import { defineEntity, lifecycle, custom, ephemeral } from './_helpers.js';

export default defineEntity(
    'workflow',
    {
        'template.updated':    lifecycle(),
        'template.deleted':    lifecycle(),
        'template.published':  custom({ scope: 'state' }),
        'instance.started':    custom({ scope: 'workflow' }),
        'instance.completed':  custom({ scope: 'workflow' }),
        'instance.failed':     custom({ scope: 'workflow' }),
        'instance.suspended':  custom({ scope: 'workflow' }),
        'instance.cancelled':  custom({ scope: 'workflow' }),
        'task.decided':        custom({ scope: 'workflow' }),
        'task.assigned':       custom({ scope: 'workflow' }),
        'task.completed':      custom({ scope: 'workflow' }),
        'task.slaWarning':     custom({ scope: 'state' }),
        'task.slaBreached':    custom({ scope: 'state' }),
        'task.slaEscalated':   custom({ scope: 'state' }),
        'informed.assigned':   custom({ scope: 'workflow' }),
        'informed.read':       custom({ scope: 'workflow' }),
        notify:                custom({ scope: 'workflow' }),
        'gate.resume':         custom({ scope: 'workflow' }),
        'loop.iteration':      ephemeral({ scope: 'workflow' }),
    },
    { includeDefaultLifecycle: false },
);
